import React, {Component} from 'react';
import {connect} from "react-redux";
import Validate from 'app/validation/validation';

import './index.scss';

import {getStreetByCityId, setStreetList, saveUserAddress, updateUserAddress} from '../../../../redux/actions';

//components
import AnimatedInput from '../../../../components/forms/animated_input';
import AutoComplete from "../../../../components/forms/autocomplete";
import Recaptcha from "../../../../components/services/google/recaptcha";

class AddForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            first_try: true,
            form: {
                home_num: {
                    val: '',
                    valid: false,
                    rules: ['not_empty'],
                    errMsg: ''
                },
                floor_num: {
                    val: '',
                    valid: false,
                    rules: [],
                    errMsg: ''
                },
                apartment: {
                    val: '',
                    valid: false,
                    rules: [],
                    errMsg: ''
                },
                zip_code: {
                    val: '',
                    valid: false,
                    rules: [],
                    errMsg: ''
                }
            },
            city: {
                errMsg: '',
                selected: -1,
                valid: false,
                query: '',
            },
            street: {
                errMsg: '',
                selected: -1,
                valid: false,
                query: '',
            },
        };
    }

    componentDidMount() {
        const data = this.props.data;

        // if data !== false than the form is on update mode
        if (this.props.data) {
            this.setState({
                ...this.state.form, form: {
                    home_num: {...this.state.form.home_num, val: data.house_num},
                    floor_num: {...this.state.form.floor_num, val: data.floor_num},
                    apartment: {...this.state.form.apartment, val: data.apartment},
                    zip_code: {...this.state.form.zip_code, val: data.zip_code}
                },
                city: {...this.state.city, selected: data.city_id, query: data.city_name},
                street: {...this.state.street, selected: data.street_id, query: data.street_name}
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        let streetListChanged = false;

        if (nextProps.streetList) {
            if (!this.props.streetList) {
                streetListChanged = true;
            } else if (nextProps.streetList.cityId !== this.props.streetList.cityId) {
                streetListChanged = true;
            }
        }

        const stateChange = nextState !== this.state;

        return streetListChanged || stateChange;
    }

    handleInputChange = (evt) => {
        let {name, value} = evt.target;
        if (name === 'home_num') {
            if (value > 4) value = value.slice(0, 4);
        } else {
            if (value > 8) value = value.slice(0, 8);
        }
        let validate = Validate(value, this.state.form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;
        let new_state = {
            ...this.state.form,
            [name]: {...this.state.form[name], val: value, valid: is_valid, errMsg: msg}
        };
        this.setState({form: new_state});
    }

    handleSubmit = (e) => {

        e.preventDefault();
        let form_valid = true;
        let new_state = this.state.form;

        for (let field in this.state.form) {
            let validate = Validate(this.state.form[field].val, this.state.form[field].rules);
            let is_valid = validate.valid;
            let msg = validate.msg;

            new_state[field].valid = is_valid;
            new_state[field].errMsg = msg;

            if (is_valid === false) {
                form_valid = false;
            }
        }

        const city = this.state.city.selected !== -1;

        const street = this.state.street.selected !== -1;

        if (!city) {
            this.setState({city: {...this.state.city, errMsg: 'אנא בחרו עיר'}});
        }
        if (!street) {
            this.setState({street: {...this.state.street, errMsg: 'אנא בחרו רחוב'}});
        }

        this.setState({form: new_state, first_try: false});

        if (form_valid && city && street) {
            let grecaptcha = window.grecaptcha
            grecaptcha.ready(() => {
                grecaptcha.execute('6Ldo2VMbAAAAAMIhQQEj49fYSWSLcuqSl-D7Fjh8', {action: 'submit'}).then((token) => {
                    const state = this.state;

                    const payload = {
                        cityId: state.city.selected,
                        streetId: state.street.selected,
                        houseNum: state.form.home_num.val,
                        apartment: state.form.apartment.val,
                        floor: state.form.floor_num.val,
                        zipCode: state.form.zip_code.val,
                    };
                    payload['g-recaptcha-response'] = token;


                    //update an existing address
                    if (this.props.data) {
                        payload['addressId'] = this.props.data.id;
                        this.props.updateUserAddress(payload);
                    }
                    // adding new address
                    else {
                        this.props.saveUserAddress(payload);
                    }

                    setTimeout(() => {
                        this.props.onSubmit();
                    }, 1000);
                })
            })
        }
    };

    showErrorMsg = (name) => {
        return !this.state.form[name].valid && !this.state.first_try;
    };

    getCities = () => {
        const data = this.props.citiesArr;
        let res = [];
        for (let key in data) {
            res.push({text: data[key].text, id: data[key].id});
        }
        return res;
    };

    clearFieldAutocomplete = (field) => {
        if (field === 'city') {
            this.props.setStreetList(false);
        }
        this.setState({[field]: {...this.state[field], query: '', selected: -1}});
    };

    fieldOnSelected = (id, text, field) => {
        if (field === 'city') {
            this.props.getStreetByCityId({cityId: id});
        }
        this.setState({[field]: {...this.state[field], selected: id, errMsg: '', valid: true, query: text}});
    };

    fieldOnChange = (e, field) => {
        this.setState({[field]: {...this.state[field], query: e.target.value}});
    };

    getStreets = () => {
        const data = this.props.streetList.streets;

        let res = [];

        if (data) {
            for (let key in data) {
                res.push({id: data[key].id, text: data[key].title});
            }
        }

        return res;
    };


    render() {
        const text = this.props.text;

        return (
            <form id='address-from' onSubmit={this.handleSubmit}>
                <div className='top-inputs'>
                    <div className='autocomplete-container'>
                        <AutoComplete className="cities-autocomplete"
                                      placeholder={text['add_form_city']}
                                      options={this.getCities()}
                                      onSelect={(id, text) => this.fieldOnSelected(id, text, 'city')}
                                      query={this.state.city.query}
                                      onChange={(e) => this.fieldOnChange(e, 'city')}
                                      onClear={() => this.clearFieldAutocomplete('city')}
                                      selected_id={this.state.city.selected}
                        />
                        <span className='err-span'>{this.state.city.errMsg}</span>
                    </div>

                    <div className='autocomplete-container'>
                        <AutoComplete className='streets-autocomplete'
                                      placeholder={text['add_form_street']}
                                      options={this.getStreets()}
                                      onSelect={(id, text) => this.fieldOnSelected(id, text, 'street')}
                                      query={this.state.street.query}
                                      onChange={(e) => this.fieldOnChange(e, 'street')}
                                      onClear={() => this.clearFieldAutocomplete('street')}
                                      selected_id={this.state.street.selected}
                                      disabled={this.getStreets().length < 1}
                        />
                        <span className='err-span'>{this.state.street.errMsg}</span>
                    </div>
                </div>
                <div className='bottom-inputs'>
                    <div className='input-container'>
                        <AnimatedInput className={'field home_num'}
                                       value={this.state.form.home_num.val}
                                       name={'home_num'}
                                       placeholder={text['add_form_home_num']}
                                       onChange={this.handleInputChange}
                                       showError={this.showErrorMsg('home_num')}
                                       errorMessage={this.state.form.home_num.errMsg}
                                       type='number'
                        />
                        <AnimatedInput className={'field floor_num'}
                                       value={this.state.form.floor_num.val}
                                       name={'floor_num'}
                                       placeholder={text['add_form_floor_num']}
                                       onChange={this.handleInputChange}
                                       showError={this.showErrorMsg('floor_num')}
                                       errorMessage={this.state.form.floor_num.errMsg}
                                       type='number'
                        />
                    </div>

                    <div className='input-container'>
                        <AnimatedInput className={'field apartment'}
                                       value={this.state.form.apartment.val}
                                       name={'apartment'}
                                       placeholder={text['add_form_apartment']}
                                       onChange={this.handleInputChange}
                                       showError={this.showErrorMsg('apartment')}
                                       errorMessage={this.state.form.apartment.errMsg}
                                       type='number'
                        />
                        <AnimatedInput className={'field zip_code'}
                                       value={this.state.form.zip_code.val}
                                       name={'zip_code'}
                                       placeholder={text['add_form_zip_code']}
                                       onChange={this.handleInputChange}
                                       showError={this.showErrorMsg('zip_code')}
                                       errorMessage={this.state.form.zip_code.errMsg}
                                       type='number'
                        />
                    </div>
                </div>
                <button className='submit-btn' type='submit'>{text['add_form_btn']}</button>
            <Recaptcha isFunction={false}/>
            </form>
        )
    }
}


//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        userData: store.config.UserData,
        citiesArr: store.config.citiesArr,
        streetList: store.data.StreetList,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getStreetByCityId: (payload) => dispatch(getStreetByCityId(payload)),
        setStreetList: (payload) => dispatch(setStreetList(payload)),
        saveUserAddress: (payload) => dispatch(saveUserAddress(payload)),
        updateUserAddress: (payload) => dispatch(updateUserAddress(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(AddForm);
